import React from "react";
import {
  Box,
  Typography,
  Tabs,
  TabList,
  Tab,
  TabPanel,
  tabClasses,
} from "@mui/joy";
import AssetOverview from "../components/AssetOverview";
import UserOverview from "../components/UserOverview";

const Dashboard = () => {
  return (
    <Box
      sx={{
        display: "flex",
        mb: 1,
        gap: 1,
        flexDirection: "column",
        flexWrap: "wrap",
        justifyContent: "space-between",
      }}
    >
      <Typography level="h2" component="h1">
        Dashboard
      </Typography>
      <Tabs defaultValue={0} sx={{ bgcolor: "transparent" }}>
        <TabList
          tabFlex={1}
          size="sm"
          sx={{
            pl: { xs: 0, md: 4 },
            justifyContent: "left",
            [`&& .${tabClasses.root}`]: {
              fontWeight: "600",
              flex: "initial",
              color: "text.tertiary",
              [`&.${tabClasses.selected}`]: {
                bgcolor: "transparent",
                color: "text.primary",
                "&::after": {
                  height: "2px",
                  bgcolor: "primary.500",
                },
              },
            },
          }}
        >
          <Tab sx={{ borderRadius: "6px 6px 0 0" }} indicatorInset value={0}>
            Asset Overview
          </Tab>
          <Tab sx={{ borderRadius: "6px 6px 0 0" }} indicatorInset value={1}>
            User Overview
          </Tab>
        </TabList>

        <TabPanel value={0}>
          <AssetOverview />
        </TabPanel>
        <TabPanel value={1}>
          <UserOverview />
        </TabPanel>
      </Tabs>
    </Box>
  );
};

export default Dashboard;
